module.exports = __webpack_public_path__ + "img/glasses-02.163d84d9.svg";